// extracted by mini-css-extract-plugin
module.exports =  {"table":"Table-module__table--D333a","withBodyRowHover":"Table-module__withBodyRowHover--RskSu","isHeaderSticky":"Table-module__isHeaderSticky--Avfj_"};